import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { HowWeWork } from './components/HowWeWork';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { PitchPopup } from './components/PitchPopup';
export function App() {
  return <div className="min-h-screen bg-brand-bg font-sans" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <HowWeWork data-id="element-5" />
        <Contact data-id="element-6" />
      </main>

      <Footer data-id="element-7" />

      <PitchPopup data-id="element-8" />
    </div>;
}